import type { GigyaGetAccountInfo } from '@ciam/gigya-api';

export const userValidator = {
  isActiveUser: (user: GigyaGetAccountInfo): boolean =>
    user.data!.userStatus === 'active' || user.data!.userStatus === 'inactive',

  isAdUser(user: GigyaGetAccountInfo): boolean {
    return user!.socialProviders!.split(',').includes('saml-samsung-ad');
  },

  isPasswordChangeRequired(user: GigyaGetAccountInfo): boolean {
    const today: Date = new Date();
    const lastUpdatePassword: Date = new Date(user.password!.created);
    const daysSinceUpdate = (today.getTime() - lastUpdatePassword.getTime()) / (1000 * 60 * 60 * 24);

    return daysSinceUpdate >= 90;
  },

  hasChannel(user: GigyaGetAccountInfo): boolean {
    const channels = user.data?.channels || {};
    return Object.keys(channels).length > 0;
  },
};
